import axios from 'axios';
import { toast } from 'sonner';
import { store } from './store';
import offlineManager from '../utils/offlineManager';

/**
 * Configure axios with global interceptors for authentication and error handling
 * This will ensure tokens are properly attached to all requests
 */
const setupAxios = () => {
  // Request interceptor - add token to all requests automatically
  axios.interceptors.request.use(
    (config) => {
      // Get the authentication state from Redux store
      const state = store.getState();
      const user = state.auth?.user;

      if (user && user.token) {
        // Add token to headers
        config.headers.Authorization = `Bearer ${user.token}`;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor - handle authentication errors and offline detection
  axios.interceptors.response.use(
    (response) => {
      // Mark as online on successful request
      offlineManager.handleRequestSuccess();
      return response;
    },
    (error) => {
      // Handle network failures for offline detection
      offlineManager.handleRequestFailure(error);

      // Handle rate limiting (429 Too Many Requests)
      if (error.response && error.response.status === 429) {

        const retrySeconds = error.response.data?.retryAfterSeconds;
        sessionStorage.setItem('rateLimited', JSON.stringify({ retrySeconds, ts: Date.now() }));
        const msg = retrySeconds
          ? `Πάρα πολλά αιτήματα. Παρακαλώ περιμένετε ${Math.ceil(retrySeconds / 60)} λεπτά.`
          : 'Πάρα πολλά αιτήματα. Παρακαλώ περιμένετε λίγο.';
        toast.error(msg, { id: 'rate-limited', duration: 8000 });
      }
      
      // Handle 401 Unauthorized errors
      if (error.response && error.response.status === 401) {
        // Clear auth data from storage
        localStorage.removeItem('user');
        sessionStorage.removeItem('user');
        
        // Redirect to login page if not already there
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }
      }
      return Promise.reject(error);
    }
  );
};

export default setupAxios;
